import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'
import { siteConfig } from '@/constants/site'

export const SiteFooter: FC = (): ReactNode => (
    <footer className='border-t bg-background'>
        <div className='mx-auto flex max-w-6xl flex-col gap-8 px-4 py-12 sm:px-6 md:flex-row md:items-start md:justify-between'>
            <div className='max-w-sm'>
                <Logo />

                <p className='mt-4 text-sm leading-relaxed text-muted-foreground'>
                    Live video classes with a shared whiteboard, raised hands, live notes and recordings. One educator, up to 50 learners.
                </p>
            </div>

            <div className='grid grid-cols-2 gap-10 text-sm sm:grid-cols-3'>
                <div>
                    <p className='font-semibold'>
                        Product
                    </p>

                    <ul className='mt-3 flex flex-col gap-2 text-muted-foreground'>
                        <li><Link href='/#features' className='hover:text-foreground'>Features</Link></li>
                        <li><Link href='/#dual-mode' className='hover:text-foreground'>Phone + computer</Link></li>
                        <li><Link href='/#how-it-works' className='hover:text-foreground'>How it works</Link></li>
                    </ul>
                </div>

                <div>
                    <p className='font-semibold'>
                        Get started
                    </p>

                    <ul className='mt-3 flex flex-col gap-2 text-muted-foreground'>
                        <li><Link href='/login?mode=signup&role=educator' className='hover:text-foreground'>Teach a class</Link></li>
                        <li><Link href='/login?mode=signup&role=learner' className='hover:text-foreground'>Join as a learner</Link></li>
                        <li><Link href='/login' className='hover:text-foreground'>Sign in</Link></li>
                    </ul>
                </div>

                <div>
                    <p className='font-semibold'>
                        About
                    </p>

                    <ul className='mt-3 flex flex-col gap-2 text-muted-foreground'>
                        <li><Link href='/#faq' className='hover:text-foreground'>Questions</Link></li>
                        <li><Link href='/privacy' className='hover:text-foreground'>Privacy</Link></li>
                    </ul>
                </div>
            </div>
        </div>

        <div className='border-t'>
            <p className='mx-auto max-w-6xl px-4 py-5 text-xs text-muted-foreground sm:px-6'>
                {siteConfig.name}. Built for teaching that feels like a real room.
            </p>
        </div>
    </footer>
)
